<template>
  <div class="category-select-box">
    <div class="no-data-state" v-if="data.length <= 0">
      <i class="el-icon-loading"></i>
      <span>Loading categories...</span>
    </div>
    
    <ul class="main-category-list" v-if="data.length > 0">
      <li class="category-item"
        v-for="item in data" :key="item.value"
        :class="{ 'is-active' : typeSelectItem === item.value }"
        @mouseenter="getFatherValue(item)"
        @click="getFatherValue(item)">
        <span class="category-label">{{ item.label }}</span>
        <i class="el-icon-arrow-right" />
      </li>
    </ul>

    <div class="subcategory-panel" v-if="typeSon && typeSon.length > 0">
        <div class="panel-header">
            <span class="panel-title">Discover Collections</span>
        </div>
        <ul class="subcategory-grid">
            <li class="sub-item"
                v-for="item in typeSon"
                :key="item.value"
                @click="selectTypeItem(item)">
                <div class="sub-label">{{ item.label }}</div>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    typeSelect: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      typeSelectItem: this.typeSelect,
      typeSon: []
    }
  },
  watch: {
    typeSelect: {
      immediate: true,
      handler (nVal) {
        this.typeSelectItem = nVal
        const selected = this.data.find(item => item.value === nVal)
        if (selected) {
          this.typeSon = selected.children
        }
      }
    }
  },
  methods: {
    getFatherValue (item) {
      this.typeSelectItem = item.value
      this.typeSon = item.children
    },
    selectTypeItem (item) {
      this.$router.push({
        path: '/indexpage/productlist',
        query: {
          type1: this.typeSelectItem,
          type2: item.value || ''
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.category-select-box {
  position: relative;
  background: $white;
  border-radius: 20px;
  box-shadow: $shadow-sm;
  width: 260px;
  height: 480px;

  &:hover .subcategory-panel {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
  }

  .main-category-list {
    padding: 16px 0;
    
    .category-item {
      height: 48px;
      padding: 0 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      transition: all 0.2s ease;
      color: $gray-700;

      .category-label {
        font-size: 14px;
        font-weight: 600;
      }

      i { font-size: 12px; color: $gray-200; transition: all 0.2s; }

      &:hover, &.is-active {
        background: $gray-50;
        color: $primary-color;
        padding-left: 30px;
        i { color: $primary-color; transform: translateX(4px); }
      }
    }
  }

  .subcategory-panel {
    position: absolute;
    left: 100%;
    top: 0;
    width: 600px;
    height: 100%;
    background: $white;
    border-radius: 0 20px 20px 0;
    box-shadow: 20px 0 40px rgba(0,0,0,0.08);
    z-index: 100;
    padding: 32px;
    opacity: 0;
    visibility: hidden;
    transform: translateX(10px);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-left: 1px solid $gray-100;

    .panel-header {
        margin-bottom: 24px;
        .panel-title {
            font-size: 18px;
            font-weight: 800;
            color: $gray-900;
            position: relative;
            &::after {
                content: '';
                position: absolute;
                bottom: -8px;
                left: 0;
                width: 40px;
                height: 3px;
                background: $primary-color;
                border-radius: 2px;
            }
        }
    }

    .subcategory-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 16px;
      
      .sub-item {
        padding: 12px 16px;
        border-radius: 12px;
        background: $gray-50;
        cursor: pointer;
        transition: all 0.2s;
        
        .sub-label {
            font-size: 14px;
            font-weight: 600;
            color: $gray-700;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        &:hover {
          background: rgba($primary-color, 0.1);
          .sub-label { color: $primary-color; }
        }
      }
    }
  }

  .no-data-state {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    color: $gray-300;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/components/typeSelectBox.vue